import api from './apiClient';

/**
 * Notification Service
 * Polls for new collaboration invitations and triggers notifications
 */

class NotificationService {
  constructor() {
    this.pollInterval = null;
    this.lastChecked = null;
    this.onNewInvitation = null;
  }

  /**
   * Start polling for new invitations
   * @param {Function} callback - Called when new invitations are found
   * @param {number} interval - Polling interval in milliseconds (default: 30 seconds)
   */
  startPolling(callback, interval = 30000) {
    this.onNewInvitation = callback;
    this.lastChecked = Date.now();

    // Initial check
    this.checkForNewInvitations();

    // Set up polling
    this.pollInterval = setInterval(() => {
      this.checkForNewInvitations();
    }, interval);

    console.log('🔔 Notification polling started');
  }

  /**
   * Stop polling
   */
  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
      console.log('🔕 Notification polling stopped');
    }
  }

  /**
   * Check for new invitations
   */
  async checkForNewInvitations() {
    try {
      if (!localStorage.getItem('currentUser')) return;

      const invitations = await api.get('/api/collaboration/invitations');

      // Filter for new invitations (created after last check)
      const newInvitations = invitations.filter(inv => {
        const invitedAt = new Date(inv.invitedAt || inv.invited_at).getTime();
        return invitedAt > this.lastChecked;
      });

      // Update last checked timestamp
      this.lastChecked = Date.now();

      // Notify about new invitations
      if (newInvitations.length > 0 && this.onNewInvitation) {
        newInvitations.forEach(invitation => {
          this.onNewInvitation(invitation);
        });
      }
    } catch (error) {
      console.error('Error checking for new invitations:', error);
    }
  }

  /**
   * Manually trigger a notification check
   */
  async checkNow() {
    await this.checkForNewInvitations();
  }
}

// Singleton instance
const notificationService = new NotificationService();

export default notificationService;
